import type { ObjectType } from '@/@types/graphql-types';

import { VFMHelper } from '@/helpers/vfm/vfm-helper';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { getTitleContextEntityId } from '@/helpers/entity-helper';

export interface TitleModalData {
	objectId: number;
	objectType: ObjectType;
	content: {
		title: string;
		originalReleaseYear?: number | null;
	};
}

export function openTitleDetailModal(title: TitleModalData, source: string): void {
	import('@/components/modals/TitleDetailModal.vue').then(({ default: TitleDetailModal }) => {
		// Close other open modals
		VFMHelper.close();

		// Open title detail modal
		ModalHelper.openModal(
			TitleDetailModal,
			{
				entityId: getTitleContextEntityId(title.objectType, title.objectId, source),
				titleName: title.content.title,
				releaseYear: title.content.originalReleaseYear,
			},
			{ cssClass: 'jw-title-detail-modal' }
		);
	});
}
